export default __webpack_public_path__ + "static/media/IMG_9838.8f12ddf4.jpg";